<template>
    <div>
        <b-list-group-item
            class="lista-menu"
            v-if="$temAcessoView('DESP-GERAIS-REL-00')"
            @click.stop="abrirPainel()"
            ><span>DESPESAS GERAIS</span>
        </b-list-group-item>
    </div>
</template>
<script>
export default {
    methods: {
        abrirPainel() {
            this.$router.push({name: 'Avaliacoes_DespesasGerais'})
        }
    }
}
</script>
